import {UI} from "stem-core/src/ui/UIBase.js";
import {Messages} from "../../Messages.js";
import {registerStyle} from "stem-core/src/ui/style/Theme.js";
import {BlinkInput} from "../../ui/Input.jsx";
import {styleRule} from "../../../stem-core/src/ui/Style.js";
import {authService} from "../../../client/connection/services/AuthService.js";
import {AuthStartPanelStyle} from "../../common/auth/AuthStartPanel.jsx";
import {RadioButtonsInput} from "../../../core/ui/input/radio/RadioButtonsInput.jsx";
import {BaseEnum, makeEnum} from "../../../stem-core/src/state/BaseEnum.js";
import {BlinkButton} from "../../../core/ui/Button.jsx";


class CDSAccountLookupStyle extends AuthStartPanelStyle {
    @styleRule
    inputContainer = {
        display: "flex",
    };

    @styleRule
    nameInput = {
        flex: 0.7,
        marginBottom: 0,
    };

    @styleRule
    zipCodeInput = {
        marginLeft: 12,
        flex: 0.3,
        marginBottom: 0,
    };

    @styleRule
    cdsLoginMethodTypeInput = {
        width: "100%",
        display: "flex",
    };
}

@makeEnum
class CDSLoginMethod extends BaseEnum {
    static ACCOUNT_NUMBER = {name: Messages.accountNumber};
    static NAME_AND_ZIP = {name: Messages.nameAndZip};
}

@registerStyle(CDSAccountLookupStyle)
export class CDSAccountLookup extends UI.Element {
    activeSection = CDSLoginMethod.ACCOUNT_NUMBER;

    render() {
        const {styleSheet} = this;

        return [
            this.getHeaderSection(),
            <div className={styleSheet.inputContainer}>
                {this.renderInputSection()}
            </div>,
            <BlinkButton
                label={Messages.lookUpPrintMagazineButton}
                className={styleSheet.button}
                disabled={!this.canSubmit()}
                onClick={() => this.handleSubmit()}
            />
        ];
    }

    getHeaderSection() {
        const {styleSheet} = this;

        return <RadioButtonsInput
            className={styleSheet.cdsLoginMethodTypeInput}
            formatter={method => method.toString()}
            values={CDSLoginMethod.all()}
            initialValue={this.activeSection}
            onChange={(value) => {
                this.activeSection = value;
                this.redraw();
            }}
        />
    }

    renderInputSection() {
        const {styleSheet} = this;

        return (this.activeSection === CDSLoginMethod.NAME_AND_ZIP) ? [
            <BlinkInput
                ref="nameInput"
                className={styleSheet.nameInput}
                label={Messages.name}
                onEnter={() => this.handleSubmit()}
                onChange={() => this.redraw()}
            />,
            <BlinkInput
                ref="zipCodeInput"
                className={styleSheet.zipCodeInput}
                label={Messages.lookupPrintMagazineZipCode}
                onEnter={() => this.handleSubmit()}
                onChange={() => this.redraw()}
            />
        ] : [
            <BlinkInput
                ref="accountNumberInput"
                style={{flex: 1, marginBottom: 0}}
                label={Messages.accountNumber}
                onEnter={() => this.handleSubmit()}
                onChange={() => this.redraw()}
            />
        ];
    }

    canSubmit() {
        return (this.activeSection === CDSLoginMethod.NAME_AND_ZIP) ?
            (this.nameInput?.getValue() && this.zipCodeInput?.getValue()) : this.accountNumberInput?.getValue();
    }

    async handleSubmit() {
        if (!this.canSubmit()) {
            return;
        }
        const request = (this.activeSection === CDSLoginMethod.NAME_AND_ZIP) ? {
            name: this.nameInput.getValue(),
            zipCode: this.zipCodeInput.getValue(),
        } : {
            accountNumber: this.accountNumberInput.getValue(),
        };

        await authService.loginAtEndpoint("/external_providers/login_with_cds", request);
    }
}
